'use strict';

var _Switch = require('./Switch');

var _Switch2 = _interopRequireDefault(_Switch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// support `const Switch = require('Switch')` for backwards compatibility
module.exports = _Switch2.default;